
function Consultancy() {

  return (
    <div>
          <div
            className="container-fluid bg-primary py-5 mb-5 hero-header"
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.856), rgba(79, 79, 79, 0.801)), url(${process.env.PUBLIC_URL}/assets/img/visaConsultancy.jpg)`,
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Consultancy
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Consultancy
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Service Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          {/* <h6 className="section-title bg-white text-center text-primary px-3">
            Consultancy
          </h6> */}
          <h1 className="mb-5">Consultancy</h1>
        </div>
        <div className="row g-4">
                <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/visaConsultancy.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            {/* <h6 className="section-title bg-white text-start text-primary pe-3">
              Falcon Destinations Consultancy
            </h6> */}
            <h1 className="mb-4">
              <span className="text-primary">Welcome to Falcon Destinations</span>
            </h1>
            <p className="mb-4"></p>
            <p className="mb-4">
        The Falcon Destination (Pvt.) Ltd. delivers consumers everything they need for planning and purchasing a whole trip. Air Falcon portal feature Holiday Packages, Airline Tickets, Hotel Reservations and the undersigned along with his expert team presents an opportunity for the establishment of proposed international Airline to meet the remarkable standards and provision of controlling of proposed airline with highly qualified professionals.

Our proposed airline company will base its business and marketing strategies on achieving high and profitable load factors through absorption of unmet demand in three key air traffic categories un-served and underserved routes on which high unmet demands currently exists or can be readily developed, serving key niche markets where demand is either unmet or poorly served; and meeting peak traffic demands on certain key regional, seasonal, and variable routes where very high load factors can be predicted despite existing but lower quality competition or where competition cannot meet the demand. </p>
       
          </div>
        </div>
      </div>
    </div>
        </div>
      </div>
    </div>
    
    </div>
  )
}

export default Consultancy